import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withTranslation } from "react-i18next";

const propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    paragraph: PropTypes.Object
  }).isRequired,
  children: PropTypes.node,
  tag: PropTypes.oneOf(['h1', 'h2', 'h3'])
}

const defaultProps = {
  children: null,
  tag: 'h2'
}

const SectionHeader = ({
  className,
  data,
  children,
  tag,
  ...props
}) => {

  const classes = classNames(
    'section-header',
    className
  );

  const Component = tag;
  const t = props.t;
  return (
    <div>
      {(data.title || data.paragraph) &&
        <div
          className={classes}
        >
          <div className="container-xs">
            {children}
            {data.title &&
              <Component className={
                classNames(
                  'mt-0',
                  data.paragraph ? 'mb-16' : 'mb-0'
                )}
              >
                {t(data.title)}
              </Component>
            }

            {data.paragraph &&
              <div>
                {
                  t(data.paragraph.kw1) +" "+
                  t(data.paragraph.p1) +" "+
                  t(data.paragraph.p2)
                }
              </div>
            }

          </div>
        </div>
      }
    </div>
  );
}

SectionHeader.propTypes = propTypes;
SectionHeader.defaultProps = defaultProps;

export default withTranslation()(SectionHeader);
